<template>
  <div id="app">
    <commonhead :active_menu="8" />
    <div class="user_point my_style myorder_style">
      <div class="content_wrap">
        <div class="point_banner">
          <div class="img_avatar"  v-if="user_info.avatar">
            <img :src="user_info.avatar" alt="" class="pic_full">
          </div>
          <div class="gradeinfobox">
            <div class="user_grade_info">
              累计成长值：{{user_info.integral}}<span class="column_line"></span>成长值余额：{{user_info.integral}}<span class="column_line"></span>成长值等级：{{user_info.integral_desc}}
            </div>
          </div>
          <div class="icon-b1" v-if="user_info.integral>=0&&user_info.integral<100"></div>
          <div class="icon-b2" v-if="user_info.integral>=100&&user_info.integral<300"></div>
          <div class="icon-b3" v-if="user_info.integral>=300&&user_info.integral<600"></div>
          <div class="icon-b4" v-if="user_info.integral>=600"></div>
        </div>
        <div class="point_tabs">
          <div class="point_tab" :class="tabindex==0?'point_tab_active':''" @click="tab_switch(0)">成长值记录</div>
          <div class="point_tab" :class="tabindex==1?'point_tab_active':''" @click="tab_switch(1)">成长值规则</div>
        </div>
        <div class="data_list" v-if="tabindex==0">
          <Table
            :data="pointLists.data"
            style="width: 100%"
            :header-cell-style="head_style"
            :cell-style="cell_style"
          >
            <TableColumn prop="created_at" label="时间" width="199"></TableColumn>
            <TableColumn prop="reason" label="内容" width="238"></TableColumn>
            <TableColumn prop="num" label="分值" width='201'>
              <!-- <template slot-scope="scope">{{scope.row.is_paid == 1 ? '已支付':'未支付'}}</template> -->
            </TableColumn>
            <TableColumn prop="after" label="累计成长值" width='277'>
              <template slot-scope="scope">{{scope.row.after+"分"}}</template>
            </TableColumn>
            <TableColumn prop="after" label="成长值余额">
              <template slot-scope="scope">{{scope.row.after+"分"}}</template>
            </TableColumn>
          </Table>
          <!--分页器-->
          <div class="pagination pr" v-if="pointLists.total>0">
            <Pagination
              background
              @current-change="getPointLists"
              :page-size="10"
              layout="total, prev, pager, next"
              :total="pointLists.total"
            >></Pagination>
          </div>
        </div>
        <div class="rulebox"  v-if="tabindex==1">
          <p>欢迎来到鲸贝开启英语学习之旅。</p>
          <p>鲸贝用户成长值规则（下称本规则）是为了彰显用户学习进度和荣誉，同时给予相应的兑换权益，本规则适用于所有注册用户。</p>
          <p>【成长值等级】</p>
          <p>成长值分为4个等级，累计成长值达到对应等级后，解锁相应等级和鲸鱼状态图标。</p>
          <p>0&lt;=成长值&lt;100<span class="emptywidth"></span>LV1</p>
          <p>100&lt;=成长值&lt;300<span class="emptywidth"></span>LV2</p>
          <p>300&lt;=成长值&lt;600<span class="emptywidth"></span>LV3</p>
          <p>600&lt;=成长值<span class="emptywidth"></span>LV4</p>
          <p>【成长值获取方式】</p>
          <p>1、完成一节正式课+2</p>
          <p>2、完成一条评价+1</p>
          <p>3、邀请好友注册 +5</p>
          <p>【成长值有效期】</p>
          <p>海枯石烂，不过期，不清零。</p>
          <p>【成长值使用】</p>
          <p>鲸贝英语成长值可用于鲸贝官网的所有产品的相应权益，且仅限于鲸贝网站（包括app）使用，不可通过电话或其他渠道兑换权益，不找零，不折现。</p>
          <p>即将开放相应的成长值兑换权益，敬请关注！</p>
          <p>【成长值规则修订】</p>
          <p>鲸贝运营团队可以依据实际情况，对本规则做适当修订并提前通知用户，公司保留解释权。</p>
        </div>
      </div>
    </div>
    <div class="pay_model"></div>
    <!--底部信息-->
    <div class="bottombox">
      <commonbottom />
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
import commonbottom from "../common/common_bottom";
import { Table, TableColumn, Pagination } from "element-ui";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot,
    Table,
    TableColumn,
    Pagination,
    commonbottom
  },
  data: function() {
    return {
      head_style:{
        background:'rgba(28, 154, 244, 0.1)',
        color:'rgba(40,40,40,1)',
        'text-align':'center',
        'font-size': '20px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '0',
        'line-height': '50px'
      },
      cell_style:{
        color:'#666',
        'text-align':'center',
        'font-size': '16px',        
        'font-family': 'PingFang',
        'font-weight': '500',
        'padding': '20px 0',
        'line-height': '76px',
        'border-bottom-color': '#eee' 
      },
      tabindex: 0,
      user_info: {},
      pointLists:{}
    };
  },
  mounted: function() {
    this.get_info();
    this.getPointLists(1);
  },
  methods: {
    tab_switch(index){
      this.tabindex = index;
    },
    get_info() {
      let self = this;
      common.requestFun(self, "get", "/student/profile", {}, (res) => {
        if (res.data.code == 200) {
          self.user_info = res.data.data;
        } else {
          if (res.data.msg && res.data.code == 401) {
            self.$message({
              message: "请登录",
              type: "error",
              center: true,
            });
          }
          self.$router.push("./");
        }
      });
    },
    getPointLists(page){
      let self = this;
      common.requestFun(
        self,
        "get",
        "/student/integral/logs",
        {
          page: page,
          pagesize: 10
        },
        res => {
          if (res.data.code == 200||res.data.code == 'ok') {
            self.pointLists = res.data.data;
          }
        }
      );
    }
  }
};
</script>
<style scoped src="./index.css"></style>
